<template>
  <PageHeader
    title="Idézet"
    hero-class="bg-event"
    :breadcrumb="[ 'Folkszemle',{ name:'Idézetgyűjtemény', url:'/folkszemle/idezetgyujtemeny'}, entity.title ]"
  >
    <div
      v-if="isAdmin()"
      class="float-right mt-[-45px] flex" 
    >
      <nuxt-link
        :to="'/admin/folkszemle/idezetgyujtemeny/idezet/' + entity.id"
        class="action-icon icon-yellow mr-4"
      >
        <i
          class="fas fa-cog pr-0"
          title="Idézet szerkesztése"
        />
      </nuxt-link>
    </div>
    <div class="bg-white w-full ">
      <div
        v-if="entity.id"
        class="flex flex-col gap-6 p-4 lg:p-10  place-items-center"
      >
        <EntityRow 
          :image="getMainImgObj(entity)"
          :no-box-slot="true"
          has-image-subtitle
          has-image-padding
          :image-subtitle="
            (entity.image.title ? ('<strong>'+ entity.image.title +'</strong><br>') : '') + (entity.image.subtitle ? entity.image.subtitle : '')
          "
        >
          <template #body>
            <div class="flex flex-row w-full h-full">
              <div class="flex flex-col w-full justify-center">
                <h2 class="font-source-serif-pro text-3xl font-semibold text-red group-hover:text-yellow">
                  {{ entity.title }}
                </h2>
                <p class="my-[10px]">
                  {{ entity.content }}
                </p>

                <!-- TODO atadni kepalairaskent -->
                <p
                  v-if="entity.image"
                  class="text-center"
                >
                  <strong v-if="entity.image.title">{{
                    entity.image.title
                  }}</strong>
                  <br v-if="entity.image.title && entity.image.subtitle">
                  <span v-if="entity.image.subtitle">{{
                    entity.image.subtitle
                  }}</span>
                </p>
                <p v-if="entity.sources && entity.sources.length">
                  <i
                    v-for="source in entity.sources"
                    :key="source.name"
                    class="author"
                  >
                    <a
                      v-if="source.url"
                      :href="source.url"
                      class="text-dark"
                      target="_blank"
                    >
                      {{ source.source }} {{ entity.source }}
                    </a>
                    <span v-else>{{ source.source }} {{ entity.source }}</span>
                  </i>
                </p>
                <hr v-if="entity.footer">
                <p v-if="entity.footer">
                  <i class="footer">
                    {{ entity.footer }}
                  </i>
                </p>
                <div
                  v-if="entity.themes && entity.themes.length > 0"
                  class="mt-2"
                >
                  <div class="flex">
                    <img
                      src="/img/bookmark_icon.svg"
                      alt=""
                    >
                    <ul class="text-[#A4A4A4] flex">
                      <li
                        v-for="(item2, index2) in entity.themes"
                        :key="index2"
                        class="mr-2"
                      >
                        <nuxt-link :to="'/tallozo?search=themes.type:' + item2.type">
                          {{ item2.type }}<span v-if="index2!==entity.themes.length-1">,</span>  
                        </nuxt-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </EntityRow>
      </div>
      <div
        v-if="entity.quotes && (entity.quotes.author || entity.quotes.theme)"
      >
        <MainTitle
          title="Kapcsolódó idézetek"
          subtitle="Idézetgyűjtemény"
          sublink="/folkszemle/idezetgyujtemeny"
        />
        <div
          v-if="entity.quotes.author"
          class="flex flex-col gap-6 p-4 lg:px-10 lg:pt-10 place-items-center"
        >
          <!-- author -->
          <nuxt-link
            :to="
              '/folkszemle/idezetgyujtemeny/idezet/' +
                entity.quotes.author.id +
                '/' +
                entity.quotes.author.slug
            "
            title="Megtekintés"
          >
            <!-- :image="getMainImgObj(entity.quotes.author)" -->
            <EntityRow 
              :no-box-slot="true"
            >
              <template #body>
                <div class="flex flex-row w-full h-full">
                  <div class="flex flex-col w-full lg:w-9/12 justify-center">
                    <h2 class="font-source-serif-pro text-3xl font-semibold text-red group-hover:text-yellow">
                      {{ entity.quotes.author.title }}
                    </h2>
                    <p class="my-[10px]">
                      {{ entity.quotes.author.content.slice(0,156) + '...' }}
                    </p>

                    <!-- TODO atadni kepalairaskent -->
                    <!-- <p
                      v-if="entity.quotes.author.image"
                      class="text-center"
                    >
                      <strong v-if="entity.quotes.author.image.title">{{
                        entity.quotes.author.image.title
                      }}</strong>
                      <br
                        v-if="
                          entity.quotes.author.image.title &&
                            entity.quotes.author.image.subtitle
                        "
                      >
                      <span v-if="entity.quotes.author.image.subtitle">{{
                        entity.quotes.author.image.subtitle
                      }}</span>
                    </p>
                    <p
                      v-if="
                        entity.quotes.author.sources &&
                          entity.quotes.author.sources.length
                      "
                    >
                      <i
                        v-for="source in entity.quotes.author.sources"
                        :key="source.name"
                        class="author"
                      >{{ source.source }}</i>
                      {{ entity.quotes.author.source }}
                    </p>

                    <div
                      v-if="
                        entity.quotes.author.themes && entity.quotes.author.themes.length
                      "
                      class="flex mt-2"
                    >
                      <img
                        src="/img/bookmark_icon.svg"
                        alt=""
                      >
                      <ul class="flex text-[#A4A4A4]">
                        <li
                          v-for="(item, index) in entity.quotes.author.themes"
                          :key="index"
                        >
                          <nuxt-link
                            class="mr-2"
                            :to="
                              '/folkszemle/idezetgyujtemeny?filter[theme]=' + item.type
                            "
                          >
                            {{ item.type }}<span v-if="index!== entity.quotes.author.themes.length-1">,</span>
                          </nuxt-link>
                        </li>
                      </ul>
                    </div> -->
                  </div>
                </div>
              </template>
            </EntityRow>
          </nuxt-link>
        </div>
        <div
          v-if="entity.quotes.theme"
          class="flex flex-col gap-6 p-4 lg:px-10 lg:pt-10 place-items-center"
        >
          <!-- theme -->
          <nuxt-link
            :to="
              '/folkszemle/idezetgyujtemeny/idezet/' +
                entity.quotes.theme.id +
                '/' +
                entity.quotes.theme.slug
            "
            title="Megtekintés"
          >
            <!-- 
              :image="getMainImgObj(entity.quotes.theme)" -->
            <EntityRow 
              :no-box-slot="true"
            >
              <template #body>
                <div class="flex flex-row w-full h-full">
                  <div class="flex flex-col w-full lg:w-9/12 justify-center">
                    <h2 class="font-source-serif-pro text-3xl font-semibold text-red group-hover:text-yellow">
                      {{ entity.quotes.theme.title }}
                    </h2>
                    <p class="my-[10px]">
                      {{ entity.quotes.theme.content.slice(0, 256) + '...' }}
                    </p>

                    <!-- TODO atadni kepalairaskent -->
                    <!-- <p
                      v-if="entity.quotes.theme.image"
                      class="text-center"
                    >
                      <strong v-if="entity.quotes.theme.image.title">{{
                        entity.quotes.theme.image.title
                      }}</strong>
                      <br
                        v-if="
                          entity.quotes.theme.image.title &&
                            entity.quotes.theme.image.subtitle
                        "
                      >
                      <span v-if="entity.quotes.theme.image.subtitle">{{
                        entity.quotes.theme.image.subtitle
                      }}</span>
                    </p>

                    <p
                      v-if="
                        entity.quotes.theme.sources && entity.quotes.theme.sources.length
                      "
                    >
                      <i
                        v-for="source in entity.quotes.theme.sources"
                        :key="source.name"
                        class="author"
                      >{{ source.source }}</i>
                      {{ entity.quotes.theme.source }}
                    </p>

                    <div
                      v-if="
                        entity.quotes.theme.themes && entity.quotes.theme.themes.length
                      "
                      class="flex mt-2"
                    >
                      <img
                        src="/img/bookmark_icon.svg"
                        alt=""
                      >
                      <ul class="flex text-[#A4A4A4]">
                        <li
                          v-for="(item, index) in entity.quotes.theme.themes"
                          :key="index"
                        >
                          <nuxt-link
                            class="mr-2"
                            :to="
                              '/folkszemle/idezetgyujtemeny?filter[theme]=' + item.type
                            "
                          >
                            {{ item.type }}<span v-if="index!== entity.quotes.theme.themes.length-1">,</span>
                          </nuxt-link>
                        </li>
                      </ul>
                    </div> -->
                  </div>
                </div>
              </template>
            </EntityRow>
          </nuxt-link>
        </div>
      </div>
      <!-- social -->
      <div class="w-full flex flex-wrap place-content-center my-[20px] lg:py-[40px]">
        <facebook
          :url="metaUrl()"
          title="Facebook megosztás"
          button-class="mx-[8px]"
        />
        <twitter
          :url="metaUrl()"
          title="Twitter megosztás"
          button-class="mx-[8px]"
        />
        <email
          :url="metaUrl()"
          :subject="entity.title + ' | Idézetgyűjtemény | Folkrádió'"
          :text="entity.title + '%0D' + metaDescription()"
          title="Email küldés"
          button-class="mx-[8px]"
        />
      </div>
    </div>
  </PageHeader>
</template>
<script>
import { cloneDeep } from "lodash";
const facebook = () => import("~/components/rxt/social/facebook.vue");
const twitter = () => import("~/components/rxt/social/twitter.vue");
const email = () => import("~/components/rxt/social/email.vue");
import PageHeader from "~/components/folkradio/PageHeader.vue";
import EntityRow from '~/components/folkradio/EntityRow.vue';
const MainTitle = () => import("~/components/folkradio/MainTitle.vue")

export default {
  components: {
    facebook,
    twitter,
    email,
    PageHeader,
    EntityRow,
    MainTitle
  },
  head() {
    return {
      titleTemplate: this.entity.title + " | Idézetgyűjtemény ",
      meta: [
        {
          hid: "title",
          name: "title",
          content: this.entity.title + " | Idézetgyűjtemény"
        },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: this.entity.title + " | Idézetgyűjtemény"
        },
        {
          hid: "description",
          name: "description",
          content: this.metaDescription()
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: this.metaDescription()
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: "Folkrádió"
        },
        {
          hid: "og:url",
          name: "og:url",
          property: "og:url",
          content: this.metaUrl()
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: this.getMainImg(this.entity)
        }
      ]
    };
  },
  data() {
    return {
      entity: {},
    };
  },
  async asyncData(context) {
    try {
      let returnUrl = "/folkszemle/idezetgyujtemeny";
      if (!process.server) {
        returnUrl = context.app.router.history.current.fullPath;
      }

      const response = await context.app.$axios.get(
        "/quotes/" + context.params.id
      );

      const entity = response.data.data;

      return {
        entity,
        returnUrl
      };
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return context.error({
          statusCode: 404,
          message: "Cikk nem található!"
        });
      } else {
        return context.error({
          statusCode: 500,
          message: "Szerver hiba, kérlek lépj kapcsolatba az üzemeltetőkkel!"
        });
      }
    }
  },
  methods: {
    metaDescription() {
      return this.entity.content;
    },
    metaUrl() {
      return (
        this.$getDomain() +
        "/folkszemle/idezetgyujtemeny/idezet/" +
        this.entity.id +
        "/" +
        this.entity.slug
      );
    },
    getMainImgObj(entity) {
      if (entity.image) {
        return entity.image;
      }
      return null;
    },
    getMainImg(entity) {
      if (entity.image) {
        return entity.image.url;
      }
      return "/img/event-default_w240.jpg";
    }
  }
};
</script>
